import { combineReducers } from 'redux';

import {
  FETCH_COMPARTMENTS,
  FETCH_COMPARTMENTS_SUCCESS,
  FETCH_COMPARTMENTS_ERROR,
  FETCH_COMPARTMENT,
  FETCH_COMPARTMENT_SUCCESS,
  FETCH_COMPARTMENT_ERROR,
  SAVE_COMPARTMENT_SUCCESS,
  REMOVE_COMPARTMENT_SUCCESS,
  SET_COMPARTMENT_MODE,
  RESET_COMPARTMENT_SELECTED,
  CHANGE_COMPARTMENT_SORT
} from './Compartment.actions';

import { RESET_BOXES } from '../Box.actions';

const loading = (state = false, action) => {
  switch (action.type) {
    case FETCH_COMPARTMENTS:
      return true;

    case FETCH_COMPARTMENTS_SUCCESS:
    case FETCH_COMPARTMENTS_ERROR:
      return false;

    default:
      return state;
  }
};

const list = (state = {}, action) => {
  switch (action.type) {
    case FETCH_COMPARTMENTS_SUCCESS:
      return action.payload.meta;

    case FETCH_COMPARTMENTS_ERROR:
      return false;

    case SAVE_COMPARTMENT_SUCCESS:
      return {
        ...state,
        total: !action.payload.data.id ? state.total + 1 : state.total
      };

    case REMOVE_COMPARTMENT_SUCCESS:
      return {
        ...state,
        total: state.total - 1
      };

    default:
      return state;
  }
};

const sort = (state = null, action) => {
  switch (action.type) {
    case CHANGE_COMPARTMENT_SORT:
      return action.sort;

    default:
      return state;
  }
};

const desc = (state = false, action) => {
  switch (action.type) {
    case CHANGE_COMPARTMENT_SORT:
      return action.desc;

    default:
      return state;
  }
};

const meta = combineReducers({
  loading,
  list,
  sort,
  desc
});

const compartment = (state = {}, action) => {
  switch (action.type) {
    case FETCH_COMPARTMENT_SUCCESS:
    case SAVE_COMPARTMENT_SUCCESS:
      return {
        ...action.payload.data.attributes,
        id: action.payload.data.id,
        type: action.payload.data.type,
        loading: false
      };

    default:
      return state;
  }
};

const items = (state = [], action) => {
  switch (action.type) {
    case FETCH_COMPARTMENTS_SUCCESS:
      return action.payload.data.map(item => ({
        id: item.id,
        type: item.type,
        ...item.attributes
      }));

    case SAVE_COMPARTMENT_SUCCESS: {
      const current = state.find(c => String(c.id) === String(action.payload.data.id));

      if (current) {
        return state.map(c => {
          if (String(action.payload.data.id) === String(c.id)) {
            return compartment(c, action);
          }
          return c;
        });
      } else {
        return [...state, compartment({}, action)];
      }
    }

    case REMOVE_COMPARTMENT_SUCCESS:
      return state.filter(item => String(item.id) !== String(action.id));

    case FETCH_COMPARTMENTS_ERROR:
    case RESET_BOXES:
      return [];

    default:
      return state;
  }
};

const selected = (state = {}, action) => {
  switch (action.type) {
    case FETCH_COMPARTMENT:
      return {
        id: action.id,
        loading: true
      };

    case FETCH_COMPARTMENT_SUCCESS:
    case SAVE_COMPARTMENT_SUCCESS:
      return compartment(state, action);

    case FETCH_COMPARTMENT_ERROR:
    case REMOVE_COMPARTMENT_SUCCESS:
    case RESET_COMPARTMENT_SELECTED:
    case RESET_BOXES:
      return {};

    default:
      return state;
  }
};

const creatingMode = (state = false, action) => {
  switch (action.type) {
    case SET_COMPARTMENT_MODE:
      return action.payload;

    case RESET_BOXES:
      return false;

    default:
      return state;
  }
};

const reducer = combineReducers({
  meta,
  items,
  selected,
  creatingMode
});

export default reducer;
